import { iconStyles, IconsProps } from '@kite_aerolab/shared/components';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import Icons from '@kite_aerolab/shared/assets/icons'

@Component({
  selector: 'kite-icon',
  template: `
    <div #svgContainer
      (click)="onClick.emit($event)" 
      [ngClass]="icon"
      [attr.aria-label]="ariaLabel"
    >
    </div>
  `,
})
export class IconComponent implements IconsProps, AfterViewInit {
  @ViewChild("svgContainer") svgContainer: ElementRef;
  /**
   * CSS del ícono
   */
  @Input() class: string;
  /**
   * CSS del ícono
   */
  @Input() css: IconsProps['css'];
  /**
   * Tamaño del ícono
   */
  @Input() size: IconsProps['size'];
  /**
   * Nombre del ícono
   */
  @Input() name: IconsProps['name'];

  /**
   * Optional click handler
   */
   @Output() onClick: EventEmitter<any> = new EventEmitter();

  /**
   * Aria Label
   */
  @Input('aria-label') ariaLabel = '';
  
  public get icon(): string[] {
    return [
      iconStyles({
        size: this.size,
        css: this.css,
      }).className,
    ]
  }

  appendSVG(svg = '') {
    if (this.svgContainer)
      this.svgContainer.nativeElement.innerHTML = svg;
  }

  ngAfterViewInit(): void {
    this.appendSVG(Icons[this.name?? '']);
  }
}
